var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoRegalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M102.875,79.505H81.636v-2.646h20.881l0.006-11.585H47.814v11.585h21.102v2.646H47.679 c-1.336,0-2.509-1.173-2.509-2.511V64.92c0-1.286,1.102-2.292,2.509-2.292h55.196c1.329,0,2.295,0.965,2.295,2.292v12.074 C105.168,78.401,104.161,79.505,102.875,79.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.21,111.417H51.56c-1.337,0-2.509-1.172-2.509-2.51V79.15c0-1.286,1.103-2.293,2.509-2.293h17.356 v2.646h-17.22v29.266h47.157l0.005-29.619c0,0.138,0.162,0.301,0.3,0.301v-2.646c1.315,0,2.348,1.03,2.348,2.346v29.756 C101.504,110.314,100.494,111.417,99.21,111.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M82.959,111.417H67.594v-48.79h15.365V111.417L82.959,111.417z M70.238,108.771h10.075V65.274H70.238 V108.771z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.565,65.117H76.893c-0.859,0-2.128-0.78-2.685-2.042c-0.507-1.154-0.625-3.064,1.708-5.616 c1.473-1.61,6.663-6.867,11.609-6.867c2.216,0,4.071,1.079,5.361,3.12c0.999,1.577,1.276,3.221,0.824,4.887 c-1.029,3.819-5.662,6.267-5.858,6.37L87.565,65.117z M77.062,62.472h9.844c1.209-0.699,3.704-2.501,4.258-4.567 c0.25-0.935,0.084-1.843-0.509-2.779c-0.816-1.29-1.81-1.889-3.128-1.889c-3.072,0-7.123,3.235-9.655,6.008 c-0.97,1.057-1.438,2.014-1.289,2.625C76.664,62.199,76.928,62.397,77.062,62.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M73.473,65.117H62.799l-0.286-0.147c-0.195-0.103-4.832-2.55-5.861-6.37 c-0.45-1.666-0.173-3.31,0.825-4.887c1.292-2.041,3.146-3.12,5.362-3.12c4.943,0,10.134,5.256,11.607,6.867 c2.333,2.552,2.217,4.463,1.709,5.616C75.601,64.337,74.329,65.117,73.473,65.117z M63.463,62.472h9.842 c0.134-0.075,0.397-0.273,0.478-0.602c0.148-0.611-0.319-1.568-1.288-2.626c-2.534-2.771-6.584-6.007-9.655-6.007 c-1.318,0-2.312,0.599-3.127,1.889c-0.593,0.936-0.759,1.845-0.51,2.779C59.758,59.971,62.253,61.773,63.463,62.472z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoRegalo);
export default __webpack_public_path__ + "static/media/icono-regalo.37a1a2323ec1a7349fed9be5d479c250.svg";
export { ForwardRef as ReactComponent };